"use strict";var e=require("@apollo/client"),t=e.gql`
  query GetStore($storeId: ID, $clientId: String) {
    getStore(storeId: $storeId, clientId: $clientId) {
      dynamicParams
      id
      name
      code
      state
      cities {
        name
      }
    }
  }
`,r=e.gql`
  mutation CreateQuotation($createQuotationInput: CreateQuotationInput!) {
    createQuotation(createQuotationInput: $createQuotationInput) {
      clientId
      comment
      currency
      expiresAt
      id
      itemsQuantity
      number
      operationalModel
      purchasedAt
      status
    }
  }
`,o=e.gql`
  mutation DeleteMyAccount($accessToken: String!) {
    deleteMyAccount(accessToken: $accessToken) {
      success
    }
  }
`,n=e.gql`
  mutation DeleteMyAccountWithProxy(
    $authorizationCode: String!
    $redirectUrl: String!
  ) {
    deleteMyAccountWithProxy(
      authorizationCode: $authorizationCode
      redirectUrl: $redirectUrl
    ) {
      success
    }
  }
`,a=e.gql`
  fragment BaseCustomer on Customer {
    id
    name
    phoneNumber
    email
    terms
    notifications
    documentId
    uid
    customData
    addresses {
      address {
        structure
        other
      }
      addressTwo
      city
      description
      latitude
      longitude
      id
      coverage
      state
    }
  }
`,s=e.gql`
  ${a}
  mutation SignInWithProxy(
    $clientId: String!
    $authorizationCode: String!
    $redirectUrl: String!
  ) {
    signInWithProxy(
      clientId: $clientId
      authorizationCode: $authorizationCode
      redirectUrl: $redirectUrl
    ) {
      customer {
        ...BaseCustomer
      }
      token
    }
  }
`,i=e.gql`
  mutation Logout {
    logout
  }
`,d=e.gql`
  mutation restorePasswordConfirmWithProxy(
    $clientId: String!
    $restorePassDataConfirm: JSON!
  ) {
    restorePasswordConfirmWithProxy(
      clientId: $clientId
      restorePassDataConfirm: $restorePassDataConfirm
    ) {
      code
      message
    }
  }
`,u=e.gql`
  mutation restorePasswordWithProxy(
    $clientId: String!
    $restorePassData: JSON!
  ) {
    restorePasswordWithProxy(
      clientId: $clientId
      restorePassData: $restorePassData
    ) {
      name
      email
    }
  }
`,c=e.gql`
  mutation revokeOldTokensGenerateNewToken {
    revokeOldTokensGenerateNewToken
  }
`,m=e.gql`
  mutation Send2FA($send2FAInput: Send2FAInput!) {
    send2FA(send2FAInput: $send2FAInput) {
      success
      requestId
    }
  }
`,l=e.gql`
  mutation SignIn($clientId: String!, $accessToken: String!) {
    signIn(clientId: $clientId, accessToken: $accessToken) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        customData
        phoneNumberValidated
        shoppingCartVersion
        addresses {
          address {
            structure
            other
          }
          addressTwo
          city
          description
          latitude
          longitude
          id
          coverage
          state
        }
      }
      token
    }
  }
`,p=e.gql`
  mutation signInWithProxy($clientId: String!, $credentials: JSON!) {
    signInWithProxy(clientId: $clientId, credentials: $credentials) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        customData
        addresses {
          address {
            structure
            other
          }
          addressTwo
          city
          description
          latitude
          longitude
          id
          coverage
          state
        }
      }
      token
    }
  }
`,I=e.gql`
  mutation signUp(
    $clientId: String!
    $accessToken: String!
    $customerData: CustomerUpdateInput!
  ) {
    signUp(
      clientId: $clientId
      accessToken: $accessToken
      customerData: $customerData
    ) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        phoneNumberValidated
        customData
      }
      token
    }
  }
`,y=e.gql`
  mutation signUpWithProxy(
    $clientId: String!
    $customerData: CustomerUpdateInput!
  ) {
    signUpWithProxy(clientId: $clientId, customerData: $customerData) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        customData
      }
      token
    }
  }
`,g=e.gql`
  mutation updateCustomerDocumentId(
    $customerId: ID!
    $documentId: String!
    $documentType: String
  ) {
    updateCustomerDocumentId(
      customerId: $customerId
      documentId: $documentId
      documentType: $documentType
    ) {
      id
      name
      documentId
    }
  }
`,$=e.gql`
  mutation Verify2FA($verify2FAInput: Verify2FAInput!) {
    verify2FA(verify2FAInput: $verify2FAInput) {
      success
    }
  }
`,P=e.gql`
  query CanRetryOrderPayment($jobNumber: String!) {
    canRetryOrderPayment(jobNumber: $jobNumber) {
      canRetry
      cartId
      paymentStatus
      operationalModel
      store {
        id
        dynamicParams
      }
    }
  }
`,C=e.gql`
  query CustomerLoggedIn {
    customerLoggedIn {
      id
      name
      phoneNumber
      email
      terms
      notifications
      documentId
      uid
      phoneNumberValidated
      customData
      addresses {
        address {
          structure
          other
        }
        addressTwo
        city
        description
        latitude
        id
        longitude
        coverage
        state
      }
      shoppingCartVersion
    }
  }
`,h=e.gql`
  query CustomerLoyaltyDetails {
    customerLoyaltyDetails {
      qrCodeId
      points
      redemptionEquivalence {
        conversionRate
        conversionValue
      }
    }
  }
`,q=e.gql`
  query CustomerLoyaltyPointsHistory(
    $customerLoyaltyPointsHistoryInput: CustomerLoyaltyPointsHistoryInput
  ) {
    customerLoyaltyPointsHistory(
      customerLoyaltyPointsHistoryInput: $customerLoyaltyPointsHistoryInput
    ) {
      currentPage
      nextPage
      items {
        date
        details
        points
        type
      }
    }
  }
`,x=e.gql`
  query CustomerLoyaltyPointsSummary(
    $customerLoyaltyPointsSummaryInput: CustomerLoyaltyPointsSummaryInput
  ) {
    customerLoyaltyPointsSummary(
      customerLoyaltyPointsSummaryInput: $customerLoyaltyPointsSummaryInput
    ) {
      currentPage
      nextPage
      items {
        description
        expirationDate
        points
      }
    }
  }
`,v=e.gql`
  query getAuthProviderURL($clientId: String!, $operation: String!) {
    getAuthProviderURL(clientId: $clientId, operation: $operation)
  }
`,S=e.gql`
  query GetCountry($name: String!) {
    getCountry(name: $name) {
      currency
    }
  }
`,b=e.gql`
  query GetEcommerceCartPaymentMethods($cartId: ID!) {
    getEcommerceCartPaymentMethods(cartId: $cartId) {
      type
      names
      paymentConfigurationId
      groupBy
      requireDynamicBilling
    }
  }
`,A=e.gql`
  query($infoPaymentMethod: InfoPaymentMethod) {
    getInstallmentsPaymentMethods(infoPaymentMethod: $infoPaymentMethod) {
      cardExternalId
      installments {
        term
        interval
        intervalDuration
        currencyCode
        periodicPayment
      }
    }
  }
`,D=e.gql`
  query GetInstallmentsPaymentMethods(
    $getInstallmentsPaymentMethodsInput: GetInstallmentsPaymentMethodsInput!
  ) {
    getInstallmentsPaymentMethods(
      getInstallmentsPaymentMethodsInput: $getInstallmentsPaymentMethodsInput
    ) {
      installments
      rate
      amount
      totalAmount
      currency
    }
  }
`,N=e.gql`
  mutation ValidateEcommerceCart($cartId: ID!) {
    validateEcommerceCart(cartId: $cartId) {
      loyalty {
        availablePoints {
          points
          conversionRate
          conversionValue
        }
        redeemable {
          points
          conversionRate
          conversionValue
        }
        selectedRedemption {
          points
          conversionRate
          conversionValue
        }
      }
    }
  }
`,M=e.gql`
  query getOnlinePaymentMethodsByCustomer {
    getOnlinePaymentMethodsByCustomer {
      creditCards {
        cardExternalId
        cardMask
        cardBrand
      }
    }
  }
`,V=e.gql`
  query GetPasswordResetValidation(
    $passwordResetValidationInput: PasswordResetValidationInput!
  ) {
    getPasswordResetValidation(
      passwordResetValidationInput: $passwordResetValidationInput
    ) {
      forcePasswordReset
    }
  }
`,f=e.gql`
  query IsPhoneNumberValid($isPhoneNumberValidInput: IsPhoneNumberValidInput!) {
    isPhoneNumberValid(isPhoneNumberValidInput: $isPhoneNumberValidInput) {
      isValid
    }
  }
`,T=e.gql`
  query userInWhiteList($email: String!) {
    userInWhiteList(email: $email)
  }
`,L=e.gql`
  mutation UpdateEcommerceCart($updateCartInput: UpdateEcommerceCartInput!) {
  updateEcommerceCart(updateCartInput: $updateCartInput) {
    validationIssues {
      reason
      productId
      type
    }
    paymentConfigurationId
    id
  }
}
`,k=e.gql`
  mutation RetryPurchaseEcommerceCart($purchaseCartInput: PurchaseCartInput!) {
    retryPurchaseEcommerceCart(purchaseCartInput: $purchaseCartInput) {
      id
      status
      jobId
      jobNumber
      operationalModel
      lobbyScreenToken
      purchaseDetails {
        id
        jobId
        jobNumber
      }
    }
  }
`,w=e.gql`
  query GetAddresses($getAddressesInput: GetAddressesInput!) {
    getAddresses(getAddressesInput: $getAddressesInput) {
      id
      description
      address {
        structure
        other
      }
      addressTwo
      available
      latitude
      longitude
      city
      state
      zipCode
      removed
      customerId
      distanceToStore
    }
  }
`,U=e.gql`
  query GetStoresNearbyByCoords(
    $clientId: String!
    $operationalModel: OperationModel!
    $coordinates: Coords!
  ) {
    getStoresNearbyByCoords(
      clientId: $clientId
      operationalModel: $operationalModel
      coordinates: $coordinates
    ) {
      id
      name
      code
      phone
      state
      cities {
        name
      }
      address
      country
      dynamicParams
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
      usedIfNotCoverage
    }
  }
`,R=e.gql`
  mutation UpsertAddress($upsertAddressInput: UpsertAddressInput!) {
    upsertAddress(upsertAddressInput: $upsertAddressInput) {
      id
      description
      address {
        structure
        other
      }
      addressTwo
      available
      latitude
      longitude
      city
      state
      zipCode
      removed
      customerId
      distanceToStore
    }
  }
`,E=e.gql`
  mutation UpdateProductInEcommerceCart(
    $updateProductInCartInput: UpdateProductInCartInput!
  ) {
    updateProductInEcommerceCart(
      updateProductInCartInput: $updateProductInCartInput
    ) {
      id
      validationIssues {
        reason
        productId
        type
      }
    }
  }
`,F=e.gql`
  query ValidateCoverage($validatedCoverageInput: ValidatedCoverageInput!) {
    validateCoverage(validatedCoverageInput: $validatedCoverageInput) {
      coverage
    }
  }
`;exports.A=I,exports.B=y,exports.C=g,exports.D=T,exports.E=$,exports.F=L,exports.G=k,exports.H=w,exports.I=U,exports.J=R,exports.K=E,exports.L=F,exports.a=C,exports.b=h,exports.c=r,exports.d=q,exports.e=x,exports.f=o,exports.g=P,exports.h=n,exports.i=v,exports.j=S,exports.k=b,exports.l=A,exports.m=D,exports.n=N,exports.o=M,exports.p=t,exports.q=V,exports.r=f,exports.s=i,exports.t=d,exports.u=u,exports.v=c,exports.w=m,exports.x=l,exports.y=s,exports.z=p;